<template>
<div class="authorization">
    <template v-if="is_logged_in">
        <div class="text-xs-center">
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <v-btn class="hidden-sm-and-down"
                           flat color="text_navbar"
                           dark v-on="on">
                        <span>Личный кабинет</span>
                        <v-icon medium right>account_circle</v-icon>
                    </v-btn>
                    <v-btn class="hidden-md-and-up"
                           color="text_navbar"
                           icon flat dark v-on="on">
                        <v-icon>more_vert</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-tile v-for="(item, index) in menu_logged_in" :key="index" :to="item.route">
                        <v-icon left>{{ item.icon }}</v-icon>
                        <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                    <v-divider></v-divider>
                    <v-list-tile @click="toggle_login">
                        <v-icon left>exit_to_app</v-icon>
                        <v-list-tile-title>Выйти</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </div>
    </template>
    <template v-else>
        <v-btn class="hidden-sm-and-down"
               @click="toggle_login"
               flat color="text_navbar">
            <span>Войти</span>
            <v-icon right>how_to_reg</v-icon>
        </v-btn>
        <v-btn class="hidden-md-and-up btn-mini"
               @click="toggle_login"
               flat color="text_navbar">
            <v-icon>how_to_reg</v-icon>
        </v-btn>
    </template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card>
                    <v-form ref="login_form" v-model="valid" lazy-validation>
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>Авторизация</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon large @click="dialog = false">
                                <v-icon large>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-alert :value="error_login" type="error">
                                        {{error_login_text}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-text-field prepend-icon="person"
                                          label='Имя пользователя'
                                          :rules="rules.required" required
                                          v-model="login" type="text">
                            </v-text-field>
                            <v-text-field prepend-icon="lock" label='Пароль'
                                          v-model="password"
                                          :append-icon="show_password ? 'visibility_off' : 'visibility'"
                                          :type="show_password ? 'text' : 'password'" counter
                                          :rules="rules.required" required
                                          @click:append="show_password = !show_password">
                            </v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-container grid-list-md pa-1>
                                <v-layout row wrap align-center justify-center>
                                    <vue-recaptcha class="hidden-xs-only"
                                                   theme="light" size="normal"
                                                   ref="login_recaptcha"
                                                   @verify="onVerify"
                                                   @expired="onExpired"
                                                   :sitekey="sitekey">
                                    </vue-recaptcha>
                                    <vue-recaptcha class="hidden-sm-and-up"
                                                   theme="light" size="compact"
                                                   ref="login_recaptcha"
                                                   @verify="onVerify"
                                                   @expired="onExpired"
                                                   :sitekey="sitekey">
                                    </vue-recaptcha>
                                </v-layout>
                                <v-layout row wrap align-space-between>
                                    <v-flex xs12 md6 px-1 pt-4 pb-2>
                                        <v-btn block color="secondary"
                                               @click="dialog = false"
                                        >Отмена
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 md6 px-1 pt-4 pb-2>
                                        <v-btn block color="primary" :loading="is_loading"
                                               :disabled="!valid || !recaptcha" @click="validate"
                                        >Войти
                                        </v-btn>
                                    </v-flex>
                                    <v-divider></v-divider>
                                    <v-flex xs12 md6 px-1 pb-2>
                                        <v-btn block flat color="secondary"
                                               @click="dialog = false" to="/new-account"
                                        >Нет аккаунта?
                                        </v-btn>
                                    </v-flex>
                                    <v-flex xs12 md6 px-1 pb-2>
                                        <v-btn block flat color="error"
                                               @click="dialog = false" to="/password-restore"
                                        >Забыли пароль?
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-dialog>
</div>
</template>

<script>
    import $ from 'jquery';
    import { Globals } from '@/globals.js';
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        name: "Auth",
        data() {
            return {
                dialog: false,
                login: '',
                password: '',
                show_password: false,
                error_login: false,
                error_login_text: '',
                // Logged-In Menu
                menu_logged_in: [
                    {title: 'Профиль', icon: 'account_box', route: '/account'},
                    {title: 'Заказы', icon: 'receipt', route: '/orders'},
                ],
                // Validate
                valid: false,
                recaptcha: false,
                recaptcha_validation: '',
                sitekey: Globals.RECAPTCHA_SITE_KEY,
                // Rules
                rules: {
                    required: [
                        v => !!v || 'Это поле обязательно для заполнения',
                    ],
                },
                // Loading
                is_loading: false,
            }
        },
        computed: {
            is_logged_in() { return this.$store.getters.logged_state },
        },
        components: {
            VueRecaptcha,
        },
        methods: {
            toggle_login() {
                if(this.is_logged_in)
                    this.exec_logout();
                else
                    this.dialog = true;
            },
            exec_login() {
                this.is_loading = true;
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.AUTH + 'token/login/',
                    type: "POST",
                    data: {
                        username: this.login,
                        password: this.password
                    },
                    success: (response) => {
                        //console.log(response.auth_token)
                        sessionStorage.setItem("auth_token", response.auth_token);
                        this.$router.go(this.$router.currentRoute);
                    },
                    error: (response) => {
                        if (response.status === 400){
                            this.error_login = true;
                            this.error_login_text = "Логин или пароль указан неверно!";
                        } else {
                            this.error_login = true;
                            this.error_login_text = "Internal server error. Please try again later.";
                        }
                    },
                    complete: () => {
                        this.is_loading = false;
                    }
                })
            },
            exec_logout() {
                $.ajax({
                    url: '' + Globals.API.ROOT + Globals.API.AUTH + 'token/logout/',
                    type: "POST",
                    data: {
                    },
                    success: () => {
                        //console.log(response.auth_token)
                        sessionStorage.removeItem('auth_token');
                        this.$router.go(this.$router.currentRoute);
                    },
                    error: (response) => {
                        if (response.status === 400){
                            this.error_login = true;
                            this.error_login_text = 'Ошибка: ' + response.responseJSON.detail;
                        }
                    }
                })
            },
            // Validation
            validate() {
                if (this.$refs.login_form.validate() && this.recaptcha) {
                    this.exec_login();
                }
            },
            // RE-Captcha
            onVerify: function (response) {
                //console.log('Verify: ' + response);
                this.recaptcha_validation = response;
                this.recaptcha = true;
            },
            onExpired: function () {
                //console.log('Expired')
                this.recaptcha_validation = '';
                this.recaptcha = false;
            },
            resetRecaptcha() {
                this.recaptcha = false;
                this.recaptcha_validation = '';
                this.$refs.login_recaptcha.reset() // Direct call reset method
            },
            // Form Reset
            resetForm() {
                this.$refs.login_form.reset();
                this.resetRecaptcha();
            },
        },
    }
</script>

<style scoped>

</style>